import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

export const SessionExpiredDialog = ({ open, onClose, message = "Session expired" }) => {
  // Auto-redirect after 5 seconds if user doesn't click button
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        handleRedirectHome();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [open]);

  const handleRedirectHome = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <Dialog
      open={open}
      onClose={handleRedirectHome}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 20px 48px rgba(0,0,0,0.24)",
          background: "linear-gradient(135deg, #FFFFFF 0%, #F8F9FE 100%)",
        },
      }}
    >
      {/* Close button - disabled */}
      <Box sx={{ position: "relative" }}>
        <IconButton
          disabled
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: alpha("#666", 0.5),
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogTitle sx={{ pb: 1, pt: 3, px: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              bgcolor: alpha("#DC2626", 0.12),
              color: "#DC2626",
            }}
          >
            <ErrorOutlineRoundedIcon sx={{ fontSize: 28 }} />
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 900, color: "#111827" }}>
            Session Expired
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 2, px: 3 }}>
        <Typography
          variant="body1"
          sx={{
            color: "#4B5563",
            lineHeight: 1.7,
            mb: 1,
          }}
        >
          {message}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#9CA3AF",
            fontSize: "0.9rem",
          }}
        >
          For security reasons, your session has been terminated. You'll be redirected to the home page in a few seconds.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 2, gap: 1 }}>
        <Button
          variant="contained"
          onClick={handleRedirectHome}
          sx={{
            fontWeight: 700,
            borderRadius: 2,
            textTransform: "none",
            background: "linear-gradient(90deg, #2563EB, #3B82F6)",
            py: 1.2,
            px: 3,
            boxShadow: "0 4px 12px rgba(37, 99, 235, 0.28)",
            "&:hover": {
              background: "linear-gradient(90deg, #1D4ED8, #2563EB)",
              boxShadow: "0 6px 16px rgba(37, 99, 235, 0.36)",
            },
          }}
        >
          Go to Home
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;
